import { type ReactNode } from 'react';
import { Button, DialogBody, DialogFooter, DialogHeader, ResponsiveDialog } from '@/ui_v3';

/** 피그마 그림 판 배경: 연보라 바탕 + 왼위 보라·오른쪽 하늘·아래 분홍 번짐. */
const NUDGE_PANEL_BACKGROUND = ['radial-gradient(ellipse 120% 80% at 10% 0%, rgba(220,210,255,1) 0%, rgba(220,210,255,0) 55%)', 'radial-gradient(ellipse 90% 70% at 100% 30%, rgba(207,230,255,1) 0%, rgba(207,230,255,0) 60%)', 'radial-gradient(ellipse 100% 80% at 40% 100%, rgba(255,217,234,0.4) 0%, rgba(255,217,234,0) 60%)', '#EEF0FF'].join(', ');
export interface ClassLinkNudgeViewProps {
  illustration: ReactNode;
  title: string;
  description: string;
  primaryLabel: string;
  secondaryLabel: string;
  onPrimary: () => void;
  onSecondary: () => void;
  onClose: () => void;
}

/**
 * 클래스 연결 권유 모달의 공통 화면 (피그마 `QuizSavedModal`·`JellyRecordModal`).
 * 받은 값만 그린다. 계측·연결 창 열기는 `ClassLinkNudge` 가 맡는다.
 * ✕만 있는 헤더 → 그림 판(높이 290 고정) → 제목 → 설명 → 버튼.
 * 그림 판 높이가 고정이라 젤리 학생 수가 1~2명이어도 모달 높이가 같다.
 */
export function ClassLinkNudgeView({
  illustration,
  title,
  description,
  primaryLabel,
  secondaryLabel,
  onPrimary,
  onSecondary,
  onClose
}: ClassLinkNudgeViewProps) {
  return <ResponsiveDialog size="md" forceDrawerOnMobile hasDrawerHandle
  // 손잡이를 그리면 끌어서 닫을 수 있어야 한다(연결 창·공유 시트와 같음). 닫힘은 ✕와 같은 onClose.
  isSwipeDismissible onClose={onClose} data-sentry-element="ResponsiveDialog" data-sentry-component="ClassLinkNudgeView" data-sentry-source-file="ClassLinkNudgeView.tsx">
      <DialogHeader ariaTitle={title} hasCloseButton onClose={onClose} data-sentry-element="DialogHeader" data-sentry-source-file="ClassLinkNudgeView.tsx" />
      <DialogBody className="flex flex-col px-md pb-md mobile-lg:px-lg" data-sentry-element="DialogBody" data-sentry-source-file="ClassLinkNudgeView.tsx">
        <div className="flex h-[290px] shrink-0 flex-col items-center justify-center overflow-hidden rounded-lg p-md" style={{
        background: NUDGE_PANEL_BACKGROUND
      }}>
          {illustration}
        </div>
        {/* 피그마 Dialog/Header: 위 16 + 줄 높이 36(글자 28을 가운데) → 글자 위아래 4px씩. */}
        <h2 className="mt-md py-3xs text-center text-heading-md-bold text-default">
          {title}
        </h2>
        {/*
          줄 높이를 19.6(140%) 대신 20 으로 둔다. 창 높이가 소수점이면 가운데 정렬(translate -50%)이
          반 픽셀에 걸려 그림 속 이미지가 흐려진다(실측: 창 높이 569.6 → 아바타가 y .59 에 놓임).
         */}
        <p className="text-center text-body-md-medium leading-5 text-neutral">
          {description}
        </p>
      </DialogBody>
      <DialogFooter className="flex flex-col gap-xs pt-0 mobile-lg:pt-0" data-sentry-element="DialogFooter" data-sentry-source-file="ClassLinkNudgeView.tsx">
        <Button variant="contained" intent="strong" size="lg" className="w-full" onClick={onPrimary} data-sentry-element="Button" data-sentry-source-file="ClassLinkNudgeView.tsx">
          {primaryLabel}
        </Button>
        <Button variant="transparent" intent="neutral" size="md" className="w-full" onClick={onSecondary} data-sentry-element="Button" data-sentry-source-file="ClassLinkNudgeView.tsx">
          {secondaryLabel}
        </Button>
      </DialogFooter>
    </ResponsiveDialog>;
}